<template>
  <div id="foot">
    <pre style="color: white; text-align: center; font-family: Arial; display: flex;">
      <b style="font-size: 14px; margin: auto; font-family: Arial;">
        Xiangyu Li Lab at Beijing Jiaotong University, Beijing 100044, China
      </b>
    </pre>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
#foot {
  background: linear-gradient(to bottom, #005BAC, #020b80);
  height: auto; /* 自动高度，以适应内容 */
  width: 100%;
  padding: 10px 0; /* 增加上下内边距 */
}

pre {
  margin: 0;
}

b {
  display: block;
  font-size: 14px;
  font-family: Arial;
  margin: auto;
  padding: 0;
  text-align: center;
  word-wrap: break-word; /* 自动换行 */
  word-break: break-word; /* 强制换行 */
  max-width: 100%; /* 保证不会超出屏幕宽度 */
  white-space: normal; /* 允许文字换行 */
}

/* 响应式布局 */
@media (max-width: 1024px) {
  b {
    font-size: 16px; /* 在中等屏幕上增大字体 */
  }
}

@media (max-width: 768px) {
  b {
    font-size: 14px; /* 在平板设备上使用适中的字体大小 */
  }
}

@media (max-width: 390px) {
  #foot {
    padding: 15px 0; /* 小屏设备时减小上下内边距 */
  }

  b {
    font-size: 12px; /* 小屏幕下字体大小减小 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Contact.vue